const StatisticIcon = () => (
	<svg width={21} height={19} viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.14429 11.4141H1.39429V17.6641H5.14429V11.4141Z"
			stroke="white"
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.6443 6.41406H8.89429V17.6641H12.6443V6.41406Z"
			stroke="white"
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M20.1443 1.41406H16.3943V17.6641H20.1443V1.41406Z"
			stroke="white"
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default StatisticIcon;
